enum LayoutType {
  SIDEBAR = 'SIDEBAR',
  DEFAULT = 'DEFAULT',
  NONE_MOBILE = 'NONE_MOBILE',
  NONE = 'NONE',
  ERROR = 'ERROR',
}

export default LayoutType;
